import React, {memo, useEffect} from "react";
import {Link, useNavigate} from "react-router";
import PropTypes from "prop-types";
import {
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Media,
  Nav,
  Navbar,
  UncontrolledDropdown,
} from "reactstrap";
import Gravatar from "react-gravatar";
import Back from "./components/Back";
import {logout} from "../../service/logout";
import {profileContext} from "../../contexts/profileContext";
import humanizeString from "string-humanize";
import {useMediaQuery} from "react-responsive";
import {requestUserProfile} from "../../redux/Actions/users.action";
import {useDispatch, useSelector} from "react-redux";
import {getUserProfile} from "../../redux/Selectors/users.selector";
import NotificationMenu from "../Notification/NotificationMenu";
import "./AppNavbar.scss";

const AppNavbar = ({brandRoute, brandText}) => {
  const dispatch = useDispatch();
  const userProfile = useSelector(getUserProfile);

  const isMobile = useMediaQuery({query: "(max-width: 659px)"});
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/auth/login", {replace: true});
  };

  useEffect(() => {
    dispatch(requestUserProfile());
  }, [dispatch]);

  return (
    <>
      {!isMobile && (
        <profileContext.Provider value={userProfile}>
          <Navbar className="navbar-top navbar-white" expand="md" id="navbar-main">
            <Container
              fluid
              id="navbar-containerfluid"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                position: "relative",
              }}
            >
              <Link
                className="h4 mb-0 d-none d-md-inline-block navbar--name ml--2 roboto-bold"
                style={{fontSize: "20px"}}
                to={brandRoute}
                data-cy={"brand-text"}
              >
                {humanizeString(brandText).toUpperCase()}
              </Link>
              <div className="back-button">
                <Back />
              </div>

              <Nav className="align-items-center d-none d-md-flex profile_icon" navbar>
                <NotificationMenu />
                <UncontrolledDropdown nav>
                  <DropdownToggle className="pr-0" data-cy={"navbar-menu"} nav>
                    <Media className="align-items-center" data-cy="userIcon">
                      <Gravatar
                        email={userProfile?.email || "test@example.com"}
                        rating="pg"
                        default="identicon"
                        className="avatar avatar-sm rounded-circle border-darker"
                      />
                      <Media className="ml-2 d-none d-md-block">
                        <span className="mb-0 navbar--name font-weight-bold">
                          {userProfile?.first_name || userProfile?.username || "profile"}
                        </span>
                      </Media>
                    </Media>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-arrow" right>
                    <DropdownItem className="noti-title" header tag="div">
                      <h6 className="text-overflow m-0">Welcome!</h6>
                    </DropdownItem>
                    <DropdownItem to="/app/profile" tag={Link} data-cy={"navbar-profile"}>
                      <i className="ni ni-single-02" />
                      <span>My profile</span>
                    </DropdownItem>
                    {/** 
                       <DropdownItem to="/app/settings" tag={Link}>
                       <i className="ni ni-settings-gear-65" />
                       <span>Settings</span>
                     </DropdownItem>
                       */}
                    <DropdownItem
                      href="https://support.energyresourceproducts.com"
                      target="_blank"
                    >
                      <i className="ni ni-support-16" />
                      <span>Support</span>
                    </DropdownItem>
                    <DropdownItem>
                      <i className="ni ni-air-baloon" />
                      <span>v{import.meta.env?.VITE_VERSION}</span>
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      href="#"
                      onClick={handleLogout}
                      data-cy={"navbar-logout"}
                    >
                      <i className="ni ni-user-run" />
                      <span data-cy="logout">Logout</span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Container>
          </Navbar>
        </profileContext.Provider>
      )}
    </>
  );
};

AppNavbar.propTypes = {
  /** This text will be shown as heading for the page */
  brandText: PropTypes.string,
  /** This is link to which router will navigate when clicked on heading */
  brandRoute: PropTypes.string,
};

export default memo(AppNavbar);
